import { useState, useEffect, useCallback } from "react"

/** Кастомный хук по переключению темы */
export const useTheme = () => {
    const [theme, setTheme] = useState<"light" | "dark">("light")

    // Инициализация темы при монтировании
    useEffect(() => {
        const saved = (localStorage.getItem("theme") as "light" | "dark") || "light"
        setTheme(saved)
        
        localStorage.setItem("theme", saved)
        document.documentElement.setAttribute("data-theme", saved)
    }, [])

    /** Функция переключения темы */
    const toggleTheme = useCallback(() => {
        const newTheme = theme === "light" ? "dark" : "light"
        setTheme(newTheme)

        localStorage.setItem("theme", newTheme)
        document.documentElement.setAttribute("data-theme", newTheme)
    }, [theme])

    return { theme, toggleTheme }
}